import classNames from "classnames";
import { ActionDiv } from "PFComponents/containers";

import keyWordsCss from "../search_box/choosen_keyword.module.scss";

type KeywordProps = {
  text: string;
  onAdd: () => void;
};

export const Keyword = ({ text, onAdd }: KeywordProps) => (
  <ActionDiv onClick={onAdd} className={classNames(keyWordsCss.item, keyWordsCss.addable)}>
    <div className={keyWordsCss.wrap}>
      <span className={keyWordsCss.text}>
        <span className={keyWordsCss.plus}>{"+ "}</span>
        {text}
      </span>
    </div>
  </ActionDiv>
);
